<script lang="ts">
	import type { CaseStudyCategory } from "../../../../core/schema/CaseStudyCategory.js";
	import { caseStudyCategoryNameMap } from "../../../../core/schema/names/caseStudyCategoryNameMap.js";
	import { getReferencesInReferenceCategoryPath } from "../../../../core/schema/paths/getReferencesInReferenceCategoryPath.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import { referencesPathMap } from "../../../../core/schema/paths/referencesPathMap.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { referencesAnchorPathMap } from "../../../../core/schema/paths/referencesAnchorPathMap.js";

	export let category: CaseStudyCategory;
	export let selected: CaseStudyCategory | undefined;
	export let largeIndex: number | undefined = undefined;

	const { TENANT_LOCALE } = getGlobalSettings();

	$: filterPath =
		selected === category
			? `/${referencesPathMap[TENANT_LOCALE]}${referencesAnchorPathMap[TENANT_LOCALE]}`
			: `/${getReferencesInReferenceCategoryPath(category, TENANT_LOCALE)}${referencesAnchorPathMap[TENANT_LOCALE]}`;
</script>

<div>
	{#if largeIndex}
		{@const isFirstInRowSm = largeIndex % 2 === 1}
		{@const isFirstInRowLg = largeIndex % 3 === 1}
		{@const isFirstInRowXl = largeIndex % 5 === 1}
		{@const borderLeftClass = `
		${isFirstInRowSm ? "sm:border-l" : "sm:border-l-0"}
		${isFirstInRowLg ? "lg:border-l" : "lg:border-l-0"}
		${isFirstInRowXl ? "xl:border-l" : "xl:border-l-0"}
	`.trim()}
		<a href={filterPath} class="group hidden flex-col md:flex">
			<span
				class="font-quicksand group-hover:text-tertiary w-12 text-[4.375rem] leading-none {selected === category
					? 'text-tertiary'
					: 'text-gray'}">{largeIndex}</span
			>
			<span
				class="text-md text-bito-black border-gray group-hover:text-tertiary group-hover:bg-mint w-[17rem] border text-center {borderLeftClass} py-6 font-extrabold {selected ===
					category && 'text-tertiary bg-mint'}">{nbspify(caseStudyCategoryNameMap[category][TENANT_LOCALE])}</span
			>
		</a>
		<a
			href={filterPath}
			class="text-2xs/4 text-bito-black border-gray text-nowrap border px-[.875rem] pb-[.125rem] pt-1 font-bold md:hidden {selected ===
				category && 'border-tertiary text-tertiary bg-mint'}"
		>
			{nbspify(caseStudyCategoryNameMap[category][TENANT_LOCALE])}
		</a>
	{:else}
		<a
			href={filterPath}
			class="text-2xs text-bito-black border-gray text-nowrap border px-4 py-1 font-bold {selected === category &&
				'border-tertiary text-tertiary bg-mint'}"
		>
			{nbspify(caseStudyCategoryNameMap[category][TENANT_LOCALE])}
		</a>
	{/if}
</div>
